/* eslint-disable no-case-declarations */
import { Injectable } from '@angular/core';
import { PlatformName, PlatformProvider } from '../../services';
import { LoggingDatabaseRepository } from '../database';
import { formatDateToString } from '@shared';
import { LogsFileExporter } from 'logs-file-exporter/src';
@Injectable()
export class LoggingExportService {
	public constructor(
		private loggingDatabaseRepository: LoggingDatabaseRepository,
		private platformProvider: PlatformProvider
	) {}

	public async export() {
		const platform = this.platformProvider.getPlatform();
		const logs = await this.loggingDatabaseRepository.getAll();
		switch (platform) {
			case PlatformName.ANDROID:
				const chunkItems: <T>(items: T[]) => T[][] = <T>(items: T[]) =>
					items.reduce((chunks: T[][], item: T, index) => {
						const chunk = Math.floor(index / 512);
						chunks[chunk] = ([] as T[]).concat(chunks[chunk] || [], item);
						return chunks;
					}, []);

				const chunkedLogs = chunkItems(logs);
				for (const chunk of chunkedLogs) {
					await LogsFileExporter.addLogs({ value: chunk });
				}

				await LogsFileExporter.exportLogs({ fileName: this.buildLogFileName() });
				break;

			case PlatformName.IOS:
				await LogsFileExporter.exportLogs({
					fileName: this.buildLogFileName(),
					logs
				});

				break;

			case PlatformName.WEB:
				const dlink: HTMLAnchorElement = document.createElement('a');
				dlink.download = this.buildLogFileName() + '.json'; // the file name
				const jsonFileContent: string = JSON.stringify(logs);
				dlink.href = 'data:text/plain;charset=utf-16,' + jsonFileContent;
				dlink.click();
				dlink.remove();

				break;

			default:
				break;
		}
	}

	private buildLogFileName(): string {
		return 'logs_' + formatDateToString(new Date());
	}
}
